/**
 * NOTE! Not use a const literals of exported from index enums,
 * const enums is constantly replaced in compile time and really not exist in lib
 */
export var AVMVERSION;
(function (AVMVERSION) {
    AVMVERSION["AVM1"] = "AVM1";
    AVMVERSION["AVM2"] = "AVM2";
})(AVMVERSION || (AVMVERSION = {}));
